import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from "@mui/material";
export const GalleryLayout = ({ children = null }) => {
    return (_jsx(Grid, { item: true, xs: 12, children: _jsx(Grid, { container: true, justifyContent: 'center', sx: { width: '100%' }, children: _jsx(Grid, { container: true, justifyContent: 'center', sx: { maxWidth: 900, width: '100%' }, children: children }, void 0) }, void 0) }, void 0));
};
//# sourceMappingURL=GalleryLayout.js.map